// // src/components/InKindForm.js
// import { useQuery } from "@tanstack/react-query";
// import { useState } from "react";
// import { useForm } from "react-hook-form";
// import { useNavigate, useParams } from "react-router-dom";
// import { toast } from "react-toastify";
// import {
//   getCategories,
//   getCitiesByState,
//   getLocalityByState,
//   getmarketsByState,
//   getSingleOffer,
//   getStates,
//   getUnits,
// } from "../api";
// import { api_url } from "../constant";
// import Client from "../utils/client";
// import AppBar from "./appBar";
// import ReactGA from "react-ga4";
// import { Header } from "./addform/Header";
// import { Footer } from "./addform/Footer";
// import { SelectInput } from "./addform/SelectInput";

// function InKindForm({ contributionType = "donate" }) {
//   // Track page view for analytics
//   ReactGA.send({
//     hitType: "pageview",
//     page: window.location.pathname,
//     title: `In-Kind ${contributionType === "donate" ? "Donation" : "Request"}`,
//   });

//   const [images, setImages] = useState([]);
//   const [media, setMedia] = useState([]);
//   const navigate = useNavigate();
//   const { id } = useParams(); // For edit functionality if needed

//   const {
//     register,
//     handleSubmit,
//     formState: { errors },
//     setValue,
//     getValues,
//     watch,
//     reset,
//   } = useForm();

//   // Fetch data using React Query
//   const { data: subCategories } = useQuery({
//     queryKey: ["categories"],
//     queryFn: () => getCategories(),
//     initialData: [],
//   });

//   const { data: states } = useQuery({
//     queryKey: ["states"],
//     queryFn: () => getStates(),
//     initialData: [],
//   });

//   const { data: cities, refetch: citiesRefetch } = useQuery({
//     queryKey: ["cities"],
//     queryFn: () => getCitiesByState(getValues().state?.value),
//     initialData: [],
//     enabled: false,
//   });

//   const { data: markets, refetch: marketRefetch } = useQuery({
//     queryKey: ["markets"],
//     queryFn: () => getmarketsByState(getValues().state?.value),
//     initialData: [],
//     enabled: false,
//   });

//   const { data: locality, refetch: localityRefetch } = useQuery({
//     queryKey: ["locality"],
//     queryFn: () => getLocalityByState(getValues().state?.value),
//     initialData: [],
//     enabled: false,
//   });

//   const { data: units } = useQuery({
//     queryKey: ["units"],
//     queryFn: () => getUnits(),
//     cacheTime: 99999,
//     staleTime: 99999,
//   });

//   // Handle form submission
//   const onSubmit = (data) => post(data);

//   const post = async (data) => {
//     // Validation
//     if (!data.offer) {
//       toast("يرجى كتابة وصف المحصول", { type: "error" });
//       return;
//     }
//     if (!data.subCategory_id || !data.subCategory_id.value) {
//       toast("يرجى اختيار المحصول", { type: "error" });
//       return;
//     }
//     if (!data.state || !data.state.value) {
//       toast("يرجى اختيار الولاية", { type: "error" });
//       return;
//     }
//     if (!data.locality || !data.locality.value) {
//       toast("يرجى اختيار المحلية", { type: "error" });
//       return;
//     }
//     if (!data.quantity || data.quantity <= 0) {
//       toast("يرجى تحديد الكمية", { type: "error" });
//       return;
//     }
//     if (!data.location) {
//       toast("يرجى تحديد الموقع التفصيلي", { type: "error" });
//       return;
//     }

//     const _data = JSON.stringify({
//       category_id: 1, // Crops category
//       quantity: data.quantity.toString(),
//       offer: data.offer,
//       location: data.location, // Specific location for in-kind
//       subCategory_id: data.subCategory_id?.value,
//       locality: data.locality ? data.locality?.value.toString() : null,
//       // market: data.market?.value.toString() || null,
//       state: data.state.value.toString(),
//       unit: data.unit.value.toString(),
//       price_per_unit: 0, // Force 0 for in-kind
//       price: 0, // Force 0 for in-kind
//       currency: "SDG", // Fixed currency for in-kind
//       offer_type: contributionType, // "donate" or "need"
//     });

//     try {
//       const response = await Client.post(api_url + "/offers/in-kind", _data, {
//         headers: {
//           Authorization: "Bearer " + localStorage.getItem("token"),
//           "Content-Type": "application/json",
//         },
//       });

//       // Check if the in-kind contribution was created successfully
//       if (response.data && response.data.id) {
//         const offerId = response.data.id;

//         // Upload images if any
//         if (images.length > 0) {
//           await uploadFiles(offerId);
//         }

//         // Show success message
//         const successMessage = contributionType === "donate"
//           ? "تم نشر التبرع بنجاح"
//           : "تم نشر الطلب بنجاح";
//         toast(successMessage, { type: "success" });

//         // Navigate back or to specific page
//         setTimeout(() => {
//           window.history.go(-1);
//         }, 1500);
//       } else {
//         throw new Error("فشل في إنشاء المساهمة العينية");
//       }
//     } catch (error) {
//       console.error("Error:", error);
//       toast("الرجاء التأكد من البيانات", { type: "error" });
//     }
//   };

//   const uploadFiles = async (offerId) => {
//     const formData = new FormData();
//     images.forEach((image, index) => {
//       formData.append("images", image);
//     });

//     try {
//       const response = await fetch(`${api_url}/files/upload-images/offer/${offerId}`, {
//         method: "POST",
//         body: formData,
//         headers: {
//           Authorization: "Bearer " + localStorage.getItem("token"),
//         },
//       });

//       const result = await response.json();

//       if (response.status > 201) {
//         throw new Error(result.message || "فشل في تحميل الصور");
//       }

//       toast("تم تحميل الصور بنجاح", { type: "success" });
//     } catch (error) {
//       console.error("Error uploading files:", error);
//       toast("فشل في تحميل الصور", { type: "error" });
//     }
//   };

//   // Handle file upload
//   const handleImageUpload = (file) => {
//     if (file) {
//       // Check file size (10 MB limit)
//       const maxSizeMB = 10;
//       if (file.size > maxSizeMB * 1024 * 1024) {
//         toast.error(`حجم الملف يتجاوز ${maxSizeMB} ميجابايت`);
//         return;
//       }

//       // Check number of files (maximum of 5)
//       if (images.length >= 5) {
//         toast.error("يمكنك تحميل حتى 5 ملفات فقط");
//         return;
//       }

//       setImages((prevFiles) => {
//         if (prevFiles.length < 5) {
//           return [...prevFiles, file];
//         }
//         return prevFiles;
//       });

//       const fileReader = new FileReader();
//       fileReader.onload = (e) => {
//         setMedia((prevMedia) => [...prevMedia, e.target.result]);
//       };
//       fileReader.readAsDataURL(file);
//     }
//   };

//   // Handle file removal
//   const removeImage = (index) => {
//     setImages((prevImages) => prevImages.filter((_, i) => i !== index));
//     setMedia((prevMedia) => prevMedia.filter((_, i) => i !== index));
//   };

//   return (
//     <div className="items-center overflow-x-hidden justify-center w-screen min-h-screen" dir="rtl">
      
//       <div className="h-10" />

//       {/* Custom Header for In-Kind */}
//       <div className="text-center">
//         <h1 className="text-2xl font-bold text-primary">
//           {contributionType === "donate" ? "تبرع بمحصول" : "طلب مساعدة عينية"}
//         </h1>
//         <p className="text-gray-600 mt-2">
//           {contributionType === "donate"
//             ? "شارك فائض محاصيلك مع من يحتاجها"
//             : "اطلب المساعدة العينية لمحاصيلك"
//           }
//         </p>
//       </div>

//       <div className="h-10"></div>

//       <div className="flex flex-col">
//         <form
//           onSubmit={handleSubmit(onSubmit)}
//           className="flex flex-col items-center justify-center"
//         >
//           {/* Crop Selection */}
//           <div className="flex flex-col w-2/6">
//             <SelectInput
//               options={subCategories.map((e) => ({ label: e.name, value: e.id }))}
//               value={getValues().subCategory_id}
//               onChange={(value) => reset({ ...getValues(), subCategory_id: value })}
//               placeholder="المحصول"
//             />
//           </div>
//           <div className="h-5" />

//           {/* Location Selection */}
//           <div className="flex flex-col lg:flex-row lg:gap-5 w-full justify-center items-center">
//             <div className="flex flex-col w-2/6 lg:w-1/6">
//               <SelectInput
//                 options={states.map((e) => ({ label: e.name, value: e.id }))}
//                 value={getValues().state}
//                 onChange={(value) => {
//                   setValue("state", value);
//                   citiesRefetch();
//                   marketRefetch();
//                   localityRefetch();
//                 }}
//                 placeholder="الولاية"
//               />
//             </div>

//             <div className="flex flex-col w-2/6 lg:w-1/6">
//               <SelectInput
//                 options={locality.map((e) => ({ label: e.name, value: e.id }))}
//                 value={getValues().locality}
//                 onChange={(value) => reset({ ...getValues(), locality: value })}
//                 placeholder="المحلية"
//                 isDisabled={locality.length === 0}
//               />
//             </div>
//           </div>
//           <div className="h-5" />

//           <div className="flex flex-col lg:flex-row lg:gap-5 w-full justify-center items-center">
//             {/* <div className="flex flex-col w-2/6 lg:w-1/6">
//               <SelectInput
//                 options={markets.map((e) => ({ label: e.name, value: e.id }))}
//                 value={getValues().market}
//                 onChange={(value) => reset({ ...getValues(), market: value })}
//                 placeholder="السوق"
//                 isDisabled={markets.length === 0}
//               />
//             </div> */}

//             <div className="h-5" />


//           </div>

//           <div className="h-5" />

//           {/* Detailed Location Input */}
//           <div className="relative w-96">
//             <span className="absolute -right-3 text-xl text-red-500">*</span>
//             <input
//               {...register("location", { required: true })}
//               className="border-[1px] h-12 p-3 mb-5 rounded-md w-full border-primary placeholder:font-bold placeholder:text-base"
//               placeholder="الموقع التفصيلي (القرية، المنطقة، المعلم...)"
//               dir="rtl"
//             />
//           </div>

//           {/* Description */}
//           <div className="relative w-96">
//             <span className="absolute -right-3 text-xl text-red-500">*</span>
//             <textarea
//               {...register("offer", { required: true })}
//               className="border-[1px] h-32 p-3 mb-5 rounded-md w-full border-primary placeholder:font-bold placeholder:text-base"
//               placeholder={
//                 contributionType === "donate"
//                   ? "وصف المحصول المتبرع به، مثلا: (قمح عالي الجودة للتوزيع على الأسر المحتاجة)"
//                   : "وصف المحصول المطلوب والسبب، مثلا: (أحتاج بذور قمح للموسم القادم بسبب الجفاف)"
//               }
//               dir="rtl"
//             />
//           </div>

//           {/* Quantity and Unit */}
//           <div className="flex flex-col-reverse lg:flex-row lg:gap-5 w-full justify-center items-center">
//             <div className="flex flex-col w-2/6 lg:w-1/6">
//               <SelectInput
//                 options={units?.map((e) => ({ label: e.name, value: e.id }))}
//                 value={getValues().unit}
//                 onChange={(value) => reset({ ...getValues(), unit: value })}
//                 placeholder="الوحدة"
//                 isDisabled={units?.length === 0}
//               />
//             </div>
//             <div className="relative">
//               <span className="absolute -right-3 text-xl text-red-500">*</span>
//               <input
//                 type="number"
//                 min="1"
//                 {...register("quantity", {
//                   valueAsNumber: true,
//                   validate: (value) => value > 0,
//                 })}
//                 className="border-[1px] h-10 p-3 rounded-md w-52 border-primary placeholder:font-bold placeholder:text-base"
//                 placeholder="الكمية"
//                 dir="rtl"
//               />
//             </div>
//           </div>

//           <div className="h-5" />

//           {/* Image Upload */}
//           <div className="w-96 h-[20vh] border-primary border-[1px] bg-gray-50 rounded-md flex justify-center items-center text-gray-500">
//             <input
//               type="file"
//               id="file"
//               className="hidden"
//               onChange={(e) => handleImageUpload(e.target.files[0])}
//               accept="image/*"
//             />
//             <label
//               htmlFor="file"
//               className="font-bold before:mr-1 before:text-red-500 cursor-pointer"
//             >
//               إرفق صورة للمحصول
//             </label>
//           </div>
//           <div className="h-5" />

//           {/* Image Previews */}
//           <div className="flex flex-row gap-3">
//             {media.length > 0 &&
//               media.map((src, index) => (
//                 <div key={index} className="relative">
//                   <img
//                     src={src}
//                     className="w-16 h-16 object-cover border border-gray-300 rounded"
//                     alt="Preview"
//                   />
//                   <button
//                     type="button"
//                     className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-sm"
//                     onClick={() => removeImage(index)}
//                   >
//                     ×
//                   </button>
//                 </div>
//               ))}
//           </div>

//           <div className="h-5" />

//           {/* Submit Button */}
//           <input
//             type="submit"
//             className="h-12 bg-green-600 text-white rounded-md w-60 font-bold cursor-pointer"
//             value={contributionType === "donate" ? "تبرع الآن" : "اطلب المساعدة"}
//           />
//         </form>
//       </div>

//       <div className="h-10" />
//       <Footer />
//     </div>
//   );
// }

// export default InKindForm;
// src/components/InKindForm.js
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  getCategories,
  getCitiesByState,
  getLocalityByState,
  getmarketsByState,
  getSingleOffer,
  getStates,
  getUnits,
} from "../api";
import { api_url } from "../constant";
import Client from "../utils/client";
import AppBar from "./appBar";
import ReactGA from "react-ga4";
import { Header } from "./addform/Header";
import { Footer } from "./addform/Footer";
import { SelectInput } from "./addform/SelectInput";

function InKindForm({ contributionType = "donate" }) {
  // Track page view for analytics
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
    title: `In-Kind ${contributionType === "donate" ? "Donation" : "Request"}`,
  });

  const [images, setImages] = useState([]);
  const [media, setMedia] = useState([]);
  const navigate = useNavigate();
  const { id } = useParams(); // For edit functionality if needed

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    watch,
    reset,
  } = useForm();

  // Fetch data using React Query
  const { data: subCategories } = useQuery({
    queryKey: ["categories"],
    queryFn: () => getCategories(),
    initialData: [],
  });

  const { data: states } = useQuery({
    queryKey: ["states"],
    queryFn: () => getStates(),
    initialData: [],
  });

  const { data: cities, refetch: citiesRefetch } = useQuery({
    queryKey: ["cities"],
    queryFn: () => getCitiesByState(getValues().state?.value),
    initialData: [],
    enabled: false,
  });

  const { data: markets, refetch: marketRefetch } = useQuery({
    queryKey: ["markets"],
    queryFn: () => getmarketsByState(getValues().state?.value),
    initialData: [],
    enabled: false,
  });

  const { data: locality, refetch: localityRefetch } = useQuery({
    queryKey: ["locality"],
    queryFn: () => getLocalityByState(getValues().state?.value),
    initialData: [],
    enabled: false,
  });

  const { data: units } = useQuery({
    queryKey: ["units"],
    queryFn: () => getUnits(),
    cacheTime: 99999,
    staleTime: 99999,
  });

  // Handle form submission
  const onSubmit = (data) => post(data);

  const post = async (data) => {
    // Validation
    if (!data.offer) {
      toast("يرجى كتابة وصف المحصول", { type: "error" });
      return;
    }
    if (!data.subCategory_id || !data.subCategory_id.value) {
      toast("يرجى اختيار المحصول", { type: "error" });
      return;
    }
    if (!data.state || !data.state.value) {
      toast("يرجى اختيار الولاية", { type: "error" });
      return;
    }
    if (!data.locality || !data.locality.value) {
      toast("يرجى اختيار المحلية", { type: "error" });
      return;
    }
    if (!data.quantity || data.quantity <= 0) {
      toast("يرجى تحديد الكمية", { type: "error" });
      return;
    }
    if (!data.location) {
      toast("يرجى تحديد الموقع التفصيلي", { type: "error" });
      return;
    }

    const _data = JSON.stringify({
      category_id: 1, // Crops category
      quantity: data.quantity.toString(),
      offer: data.offer,
      location: data.location, // Specific location for in-kind
      subCategory_id: data.subCategory_id?.value,
      locality: data.locality ? data.locality?.value.toString() : null,
      state: data.state.value.toString(),
      unit: data.unit.value.toString(),
      price_per_unit: 0, // Force 0 for in-kind
      price: 0, // Force 0 for in-kind
      currency: "SDG", // Fixed currency for in-kind
      offer_type: contributionType, // "donate" or "need"
    });

    try {
      const response = await Client.post(api_url + "/offers/in-kind", _data, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      });

      // Check if the in-kind contribution was created successfully
      if (response.data && response.data.id) {
        const offerId = response.data.id;

        // Upload images only for donations
        if (contributionType === "donate" && images.length > 0) {
          await uploadFiles(offerId);
        }

        // Show success message
        const successMessage = contributionType === "donate"
          ? "تم نشر التبرع بنجاح"
          : "تم نشر الطلب بنجاح";
        toast(successMessage, { type: "success" });

        // Navigate back or to specific page
        setTimeout(() => {
          window.history.go(-1);
        }, 1500);
      } else {
        throw new Error("فشل في إنشاء المساهمة العينية");
      }
    } catch (error) {
      console.error("Error:", error);
      toast("الرجاء التأكد من البيانات", { type: "error" });
    }
  };

  const uploadFiles = async (offerId) => {
    const formData = new FormData();
    images.forEach((image, index) => {
      formData.append("images", image);
    });

    try {
      const response = await fetch(`${api_url}/files/upload-images/offer/${offerId}`, {
        method: "POST",
        body: formData,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });

      const result = await response.json();

      if (response.status > 201) {
        throw new Error(result.message || "فشل في تحميل الصور");
      }

      toast("تم تحميل الصور بنجاح", { type: "success" });
    } catch (error) {
      console.error("Error uploading files:", error);
      toast("فشل في تحميل الصور", { type: "error" });
    }
  };

  // Handle file upload
  const handleImageUpload = (file) => {
    if (file) {
      // Check file size (10 MB limit)
      const maxSizeMB = 10;
      if (file.size > maxSizeMB * 1024 * 1024) {
        toast.error(`حجم الملف يتجاوز ${maxSizeMB} ميجابايت`);
        return;
      }

      // Check number of files (maximum of 5)
      if (images.length >= 5) {
        toast.error("يمكنك تحميل حتى 5 ملفات فقط");
        return;
      }

      setImages((prevFiles) => {
        if (prevFiles.length < 5) {
          return [...prevFiles, file];
        }
        return prevFiles;
      });

      const fileReader = new FileReader();
      fileReader.onload = (e) => {
        setMedia((prevMedia) => [...prevMedia, e.target.result]);
      };
      fileReader.readAsDataURL(file);
    }
  };

  // Handle file removal
  const removeImage = (index) => {
    setImages((prevImages) => prevImages.filter((_, i) => i !== index));
    setMedia((prevMedia) => prevMedia.filter((_, i) => i !== index));
  };

  return (
    <div className="items-center overflow-x-hidden justify-center w-screen min-h-screen" dir="rtl">
      
      <div className="h-10" />

      {/* Custom Header for In-Kind */}
      <div className="text-center">
        <h1 className="text-2xl font-bold text-primary">
          {contributionType === "donate" ? "تبرع بمحصول" : "طلب مساعدة عينية"}
        </h1>
        <p className="text-gray-600 mt-2">
          {contributionType === "donate"
            ? "شارك فائض محاصيلك مع من يحتاجها"
            : "اطلب المساعدة العينية لمحاصيلك"
          }
        </p>
      </div>

      <div className="h-10"></div>

      <div className="flex flex-col">
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="flex flex-col items-center justify-center"
        >
          {/* Crop Selection */}
          <div className="flex flex-col w-2/6">
            <SelectInput
              options={subCategories.map((e) => ({ label: e.name, value: e.id }))}
              value={getValues().subCategory_id}
              onChange={(value) => reset({ ...getValues(), subCategory_id: value })}
              placeholder="المحصول"
            />
          </div>
          <div className="h-5" />

          {/* Location Selection */}
          <div className="flex flex-col lg:flex-row lg:gap-5 w-full justify-center items-center">
            <div className="flex flex-col w-2/6 lg:w-1/6">
              <SelectInput
                options={states.map((e) => ({ label: e.name, value: e.id }))}
                value={getValues().state}
                onChange={(value) => {
                  setValue("state", value);
                  citiesRefetch();
                  marketRefetch();
                  localityRefetch();
                }}
                placeholder="الولاية"
              />
            </div>

            <div className="flex flex-col w-2/6 lg:w-1/6">
              <SelectInput
                options={locality.map((e) => ({ label: e.name, value: e.id }))}
                value={getValues().locality}
                onChange={(value) => reset({ ...getValues(), locality: value })}
                placeholder="المحلية"
                isDisabled={locality.length === 0}
              />
            </div>
          </div>
          <div className="h-5" />

          {/* Detailed Location Input */}
          <div className="relative w-96">
            <span className="absolute -right-3 text-xl text-red-500">*</span>
            <input
              {...register("location", { required: true })}
              className="border-[1px] h-12 p-3 mb-5 rounded-md w-full border-primary placeholder:font-bold placeholder:text-base"
              placeholder="الموقع التفصيلي (القرية، المنطقة، المعلم...)"
              dir="rtl"
            />
          </div>

          {/* Description */}
          <div className="relative w-96">
            <span className="absolute -right-3 text-xl text-red-500">*</span>
            <textarea
              {...register("offer", { required: true })}
              className="border-[1px] h-32 p-3 mb-5 rounded-md w-full border-primary placeholder:font-bold placeholder:text-base"
              placeholder={
                contributionType === "donate"
                  ? "وصف المحصول المتبرع به، مثلا: (قمح عالي الجودة للتوزيع على الأسر المحتاجة)"
                  : "وصف المحصول المطلوب والسبب، مثلا: (أحتاج بذور قمح للموسم القادم بسبب الجفاف)"
              }
              dir="rtl"
            />
          </div>

          {/* Quantity and Unit */}
          <div className="flex flex-col-reverse lg:flex-row lg:gap-5 w-full justify-center items-center">
            <div className="flex flex-col w-2/6 lg:w-1/6">
              <SelectInput
                options={units?.map((e) => ({ label: e.name, value: e.id }))}
                value={getValues().unit}
                onChange={(value) => reset({ ...getValues(), unit: value })}
                placeholder="الوحدة"
                isDisabled={units?.length === 0}
              />
            </div>
            <div className="relative">
              <span className="absolute -right-3 text-xl text-red-500">*</span>
              <input
                type="number"
                min="1"
                {...register("quantity", {
                  valueAsNumber: true,
                  validate: (value) => value > 0,
                })}
                className="border-[1px] h-10 p-3 rounded-md w-52 border-primary placeholder:font-bold placeholder:text-base"
                placeholder="الكمية"
                dir="rtl"
              />
            </div>
          </div>

          <div className="h-5" />

          {/* Image Upload - Only show for donations */}
          {contributionType === "donate" && (
            <>
              <div className="w-96 h-[20vh] border-primary border-[1px] bg-gray-50 rounded-md flex justify-center items-center text-gray-500">
                <input
                  type="file"
                  id="file"
                  className="hidden"
                  onChange={(e) => handleImageUpload(e.target.files[0])}
                  accept="image/*"
                />
                <label
                  htmlFor="file"
                  className="font-bold before:mr-1 before:text-red-500 cursor-pointer"
                >
                  إرفق صورة للمحصول (اختياري)
                </label>
              </div>
              <div className="h-5" />

              {/* Image Previews - Only show for donations */}
              {media.length > 0 && (
                <>
                  <div className="flex flex-row gap-3">
                    {media.map((src, index) => (
                      <div key={index} className="relative">
                        <img
                          src={src}
                          className="w-16 h-16 object-cover border border-gray-300 rounded"
                          alt="Preview"
                        />
                        <button
                          type="button"
                          className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-sm"
                          onClick={() => removeImage(index)}
                        >
                          ×
                        </button>
                      </div>
                    ))}
                  </div>
                  <div className="h-5" />
                </>
              )}
            </>
          )}

          {/* Additional Information for Requests */}
          {contributionType === "need" && (
            <div className="w-96 bg-blue-50 border border-blue-200 rounded-lg p-4 mb-5">
              <div className="flex items-start">
                <div className="text-blue-500 ml-2 mt-1">💡</div>
                <div>
                  <h4 className="font-bold text-blue-800 text-sm">نصيحة</h4>
                  <p className="text-blue-700 text-xs mt-1">
                    اذكر في الوصف سبب حاجتك للمساعدة وأي معلومات إضافية تساعد المانحين على فهم وضعك.
                  </p>
                </div>
              </div>
            </div>
          )}

          {/* Submit Button */}
          <input
            type="submit"
            className="h-12 bg-green-600 text-white rounded-md w-60 font-bold cursor-pointer hover:bg-green-700 transition-colors"
            value={contributionType === "donate" ? "تبرع الآن" : "اطلب المساعدة"}
          />
        </form>
      </div>

      <div className="h-10" />
      <Footer />
    </div>
  );
}

export default InKindForm;